import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "card card-spacer bgi-no-repeat card-xl-stretch mb-xl-8 p-5 mb-10",
  style: {"background-position":"right top","background-size":"30% auto","background-image":"url('/media/svg/shapes/abstract-2.svg')"}
}
const _hoisted_2 = { class: "text-muted fw-bolder" }
const _hoisted_3 = { href: "#" }
const _hoisted_4 = { class: "m-0 p-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrows-rotate" }, null, -1)
const _hoisted_6 = { class: "mx-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_btn_sm = _resolveComponent("a-btn-sm")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createBlock(_component_el_affix, { offset: 120 }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { md: 10 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.label), 1),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.info), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              md: 14,
              class: "right"
            }, {
              default: _withCtx(() => [
                (_ctx.Reload)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "btn btn-sm btn-flex btn-light-info btn-active-info fw-bolder px-4 mx-2",
                      onClick: _ctx.ReloadPage
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.Save)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('handleValidateClick'))),
                      class: "btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder px-8 mx-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen028.svg" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.saveLabel), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "customBtn"),
                (_ctx.backTo)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: _ctx.Cul(_ctx.backTo),
                      class: "btn btn-sm btn-flex btn-light btn-active-info fw-bolder mx-2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.backLabel), 1),
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.backAction)
                  ? (_openBlock(), _createBlock(_component_a_btn_sm, {
                      key: 3,
                      class: "btn btn-sm btn-flex btn-light btn-active-info fw-bolder mx-2",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back'))),
                      color: "primary",
                      text: _ctx.backLabel
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }))
}